<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div id="root-main-navigation">
        <v-navigation-drawer
                app
                fixed
                v-model="drawer"
        >
            <!--================Home Button================-->
            <v-list>
                <v-list-item @click="navHome">
                    <v-list-item-action>
                        <v-icon>home</v-icon>
                    </v-list-item-action>
                    <v-list-item-title>Home</v-list-item-title>
                </v-list-item>


                <!--================Mandate Section================-->
                <v-list-group
                        id="group-mandate"
                        prepend-icon="people"
                        value="true">
                    <template v-slot:activator>
                        <v-list-item @click="navMandates">
                            <v-list-item-title>Mandanten</v-list-item-title>
                        </v-list-item>
                    </template>

                    <v-list-item
                            :key="i"
                            @click="onMandateItemClicked(i)"
                            v-for="(crud, i) in mandatesEntries"
                    >
                        <v-list-item-title v-text="crud[0]"></v-list-item-title>
                        <v-list-item-action>
                            <v-icon v-text="crud[1]"></v-icon>
                        </v-list-item-action>
                    </v-list-item>

                </v-list-group>


                <!--================Packages Section================-->
                <v-list-item>
                    <v-list-item-action>
                        <v-icon id="icon-packages">mdi-package-up</v-icon>
                    </v-list-item-action>
                    <v-list-item-title @click="navPackages">Pakete</v-list-item-title>
                </v-list-item>

                <!--================News Section================-->
                <v-list-item>
                    <v-list-item-action>
                        <v-icon id="icon-news">mdi-newspaper</v-icon>
                    </v-list-item-action>
                    <v-list-item-title @click="navNews">Newsletter</v-list-item-title>
                </v-list-item>

            </v-list>

            <!--================Logout Button================-->
            <div class="pa-2">
                <v-btn @click="navLogout" block color="primary"><span class="white--text">Logout</span></v-btn>
            </div>
        </v-navigation-drawer>

        <v-app-bar app color="primary" dark fixed>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <v-toolbar-title>Baucheck Admin</v-toolbar-title>
        </v-app-bar>

        <v-footer
                app
                color="primary"
        >
            <v-spacer></v-spacer>
            <span class="white--text">&copy; Bau-checkwasduwillst</span>
        </v-footer>
    </div>
</template>

<script>
    import LoginStore from "../ts/stores/LoginStore";
    import Authentication from "../API/Authentication";

    export default {
        name: "MainNavigation",
        data: () => ({
            drawer: null,

            //Custom Data
            mandatesEntries: [
                ['Anlegen', 'add'],
            ]
        }),
        methods: {
            navHome() {
                this.$router.push("/")
            },
            navMandates() {
                this.$router.push("/mandates");
            },
            onMandateItemClicked(i) {
                if (i === 0) {
                    this.$router.push("/mandates/create");
                }
            },
            navPackages() {
                this.$router.push("/packages");
            },
            navNews() {
                this.$router.push("/news")
            },
            navLogout() {
                Authentication.logout().then(res => {
                    LoginStore.state.authToken = "";
                    this.$router.push("/")
                }).catch(err => {
                    //
                })
            }
        }
    }
</script>

<style scoped>

</style>
